import { Button, Tab } from "@chakra-ui/react";
import { useFeeChargeEventBasisChangeByUseRetrieveSuspense } from "gen/endpoints/fee-charge-event/fee-charge-event";
import { GenericSelectDataList } from "gen/model/genericSelectDataList";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SelectButton } from "shared/components/input/select/SelectButton";
import { SelectOption } from "shared/components/input/select/SelectOption";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTabs } from "shared/components/table/box/TableBoxTabs";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";

export const FeePostUseBreakdownBasisChangeTable: React.FC<{
  fundFamilyId: string;
  feeChargeEventId: string;
  onRefresh?: () => void;
  setFeeChargeEventSelected: (feeChargeEventSelected: string) => void;
  feePeriodSelectData: GenericSelectDataList;
}> = ({
  fundFamilyId,
  feeChargeEventId,
  onRefresh,
  setFeeChargeEventSelected,
  feePeriodSelectData,
}) => {
  const { t } = useTranslation(["fees", "common"]);

  const { data: useData, isFetching } =
    useFeeChargeEventBasisChangeByUseRetrieveSuspense(
      fundFamilyId,
      feeChargeEventId,
    );

  const basisNames = Object.keys(useData.basis_name_to_basis_change_table);
  const [activeBasisName, setActiveBasisName] = useState(basisNames[0]);
  const tableData = useData.basis_name_to_basis_change_table[activeBasisName];

  const tabIndex = basisNames.indexOf(activeBasisName);
  const onChangeTabIndex = (index: number) => {
    setActiveBasisName(basisNames[index]);
  };

  const emtpyTableData = { ...tableData, rows: [] };

  return (
    <TableBox>
      <TableBoxHeader>
        {basisNames.length > 1 ? (
          <TableBoxTabs index={tabIndex} onChange={onChangeTabIndex}>
            {basisNames.map((name) => (
              <Tab key={name} value={name}>
                {name}
              </Tab>
            ))}
          </TableBoxTabs>
        ) : (
          <TableBoxTitle>
            {t("fees:feeUseBreakdown.basisChangeTable.title")}
          </TableBoxTitle>
        )}
        <DataTableBoxActions>
          <SelectButton
            size="sm"
            isFilterButton={true}
            title={t("common:quarter")}
            value={feeChargeEventId}
            isOptional={false}
            onChangeValue={(value: string) => {
              setFeeChargeEventSelected(value);
            }}
          >
            {feePeriodSelectData.map((element) => (
              <SelectOption value={element.value} key={element.value}>
                {element.rich_value}
              </SelectOption>
            ))}
          </SelectButton>
          {onRefresh && (
            <Button onClick={onRefresh} isLoading={isFetching}>
              {t("common:refresh")}
            </Button>
          )}
        </DataTableBoxActions>
      </TableBoxHeader>
      <TableBoxBody>
        <DataTable
          data={isFetching ? emtpyTableData : tableData}
          isLoading={isFetching}
        />
      </TableBoxBody>
    </TableBox>
  );
};
